import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from "@mui/icons-material/Upload";
import Logo from "../../commonComponents/Logo/Logo";
// import SearchBox from "../../commonComponents/SearchBox/SearchBox";
import {
  appBar,
  dialogContainer,
  searchBoxContainer,
  searchBox,
  searchButton,
} from "./HeaderStyling";
import VideoUpload from "../VideoUploadModal/VideoUpload";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other} style={dialogContainer}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const Header = (props) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Grid container item justifyContent="space-between" style={appBar}>
        <Grid items  onClick={() => history.push("/")}>
          <Logo />
        </Grid>
        <Grid items style={searchBoxContainer}>
          <input
              type="text"
              placeholder="Search"
              style={searchBox}
              value={props.searchText}
              onChange={(e) => props.debounceSearch(e.target.value)}
            />
            <button style={searchButton}>
              <SearchIcon />
            </button>
        </Grid>
        <Grid items>
          <Button
            variant="contained"
            startIcon={<UploadIcon />}
            onClick={handleClickOpen}
            id="upload-btn"
          >
            Upload
          </Button>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
          >
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onClose={handleClose}
            >
              Upload Video
            </BootstrapDialogTitle>
            <DialogContent style={dialogContainer}>
              <VideoUpload onClose={handleClose} />
            </DialogContent>
          </BootstrapDialog>
        </Grid>
     </Grid>
    </>
  );
};

export default Header;
